import { DashboardLayout } from '@/components/DashboardLayout'

export function HistoryPage() {
  return <DashboardLayout title="History" />
}
